import { Flex, Spin } from "antd";
import styled from "styled-components";

type GlobalLoaderProps = {
  position?: "absolute" | "fixed";
  transparent?: boolean;
};

const GlobalLoader = ({
  position = "fixed",
  transparent,
}: GlobalLoaderProps) => {
  return (
    <Loader $position={position} $transparent={transparent}>
      <Flex align="center" gap="middle">
        <Spin size="large" />
      </Flex>
    </Loader>
  );
};

export default GlobalLoader;

const Loader = styled.div<{
  $position: "absolute" | "fixed";
  $transparent?: boolean;
}>`
  position: ${({ $position }) => $position};
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  opacity: ${({ $transparent }) => ($transparent ? 0.5 : 1)};
`;
